import { Snackbar, Alert, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useError } from 'services/ErrorContext';

interface AlertaProps {
  mensaje: string;
  variante?: 'filled' | 'outlined' | 'standard';
  abierto: boolean;
  severity: 'error' | 'info' | 'success' | 'warning';
  duracion?: number | null;
}

const Alerta = ({ mensaje, variante = 'standard', abierto, severity, duracion = 10000 }: AlertaProps) => {
  const { clearError } = useError();
  const [open, setOpen] = useState(abierto);
  const handleClose = () => {
    setOpen(false);
    clearError();
  };

  useEffect(() => {
    setOpen(abierto);
  }, [abierto]);

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      autoHideDuration={duracion}
    >
      <Box mt="124px" mr={2} zIndex={99999}>
        <Alert onClose={handleClose} severity={severity} variant={variante} sx={{ width: '100%' }}>
          {mensaje}
        </Alert>
      </Box>
    </Snackbar>
  );
};

export default Alerta;
